import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Input, Spin, Form, message, Checkbox, Col, Row, Radio, InputNumber,} from 'antd';
import { Config } from '../../public/js/config';
import  trans  from './translation';
import { LeftOutlined, RightOutlined,  } from '@ant-design/icons';
import './surveyScreen.css';
import '../newMain/newMain.css';

import submitImg from '../../public/img/buttonImg/submitApplication.png';
import logoImg from '../../public/img/logo.jpg';
const { TextArea } = Input;
const SurveyScreen = (props) => {

    const history = useHistory();
    const { authorizationCode, lang } = useParams();
    const [isLoad, setIsLoad] = useState(false);
    const [isShow, setIsShow] = useState(true);
    const [form] = Form.useForm();
    const [language, setLanguage] = useState(lang ?? "EN");
    const [surveyRecordModel, setSurveyRecordModel] = useState({});
    const [surveyTemplateModel, setSurveyTemplateModel] = useState({});
    const [tables, setTables] = useState([]);
    const [optionTables, setOptionTables] = useState([]);
    const [tabIndex, setTabIndex] = useState('1');

    useEffect(() => {
        if (authorizationCode) {
            checkCode()
        } else {
            message.error("Link has failed.");
            setIsShow(false);
        }
    }, []);

    const checkCode = () => {
        if(isLoad) {
            return;
        }
        let model = {authorizationCode: authorizationCode};
        setIsLoad(true);
        fetch(Config.apiServer + "partner/surveyRecord/checkAuthorizationCode", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                setIsShow(true)
                searchById();
            } else {
                message.error(data.msg);
                setIsShow(false);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }
        
    const searchById = () => {
        let model = {authorizationCode: authorizationCode};
        fetch(Config.apiServer + "partner/surveyRecord/searchById", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                searchSurveyTemplate(model);
                setSurveyRecordModel(model);
            } else {
                message.error(data.msg);
            }
        })
    }

    const searchSurveyTemplate = (model) => {
        fetch(Config.apiServer + "partner/surveyRecord/searchSurveyTemplate", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setSurveyTemplateModel(model);
                let list = [];
                for(let i = 1; i <= 10; i++) {
                    if(model['sectionAQuestion' + i + language]) {
                        list.push({
                            id: 'sectionAQuestionResult' + i,
                            question: model['sectionAQuestion' + i + language],
                        })
                    }
                }
                setTables(list);
                let optionList = [];
                for(let i = 1; i <= 13; i++) {
                    if(model['sectionCQuestion' + i + language]) {
                        optionList.push({
                            id: 'sectionCQuestionResult' + i,
                            question: model['sectionCQuestion' + i + language],
                        })
                    }
                }
                setOptionTables(optionList);
            } else {
                console.log(data.msg);
            }
        })
    }

    const handleSelect = (key) => {
        if (key === '2') {
            form.validateFields()
                .then(() => {
                    setTabIndex(key);
                    document.documentElement.scrollTop = 0;
                })
        } else {
            setTabIndex(key);
            document.documentElement.scrollTop = 0;
        }
    }

    const jump = (path) => {
        history.push(path);
    }

    const onFinish = (values) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        let model = {...surveyRecordModel, ...values, authorizationCode: authorizationCode};
        model.cohortProgIds = values?.cohortProgIds?.join(',');
        fetch(Config.apiServer + "partner/surveyRecord/update", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                jump("/surveyScreenThanks");
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    return (
        <div id="container" className='websiteTemplate surveyScreen'>
            {isShow ? <Spin size="large" spinning={isLoad} >
                <div className='websiteSysContentBox'>
                    <div className='loginLogoBox'>
                        <img src={logoImg} />
                    </div>
                    <Form form={form} onFinish={onFinish}>
                        <div className={tabIndex != '1' ? 'divHiddle' : ''}>
                            <div className='contentTitle contentTitleDisplay'>
                                {trans.surveyScreenSchool[language]}
                            </div>
                            <div className='contentTitle contentTitleDisplay'>
                                {trans.surveyScreenName[language]}
                            </div>
                            <div className='flexBox marginTopAndBot'>
                                <div className='value valueJustify'>
                                    {trans.surveyScreenDesc[language]}
                                </div>
                                <div className='value valueJustify'>
                                    {trans.surveyScreenDesc2[language]}
                                </div>
                                
                            </div> 
                            <div className='titleSize contentTitleDisplay'>
                                {trans.surveyScreenModel[language]}
                            </div>
                            <div className='titleSize'>{trans.surveyScreenModel1[language]}</div>
                            <div className='websiteSysRow'>
                                <div className='websiteSysCol'>
                                    <div className='websiteSysParam websiteSysParamMin '>1.{trans.surveyScreenInstitutionName[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="organisationName"
                                        >
                                            <Input className="input" type="text" placeholder={trans.surveyScreenInstitutionName[language]} maxLength={100} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='flexBox'>
                                <div className="label mustFill">2.{trans.surveyScreen2[language]}</div>
                            </div>          
                            <div className="checkbox">
                                <Form.Item
                                    name="cohortProgIds"
                                    rules={[
                                        { required: true, message: trans.surveyScreen2[language] },
                                    ]}
                                >
                                    <Checkbox.Group
                                        style={{
                                            width: '100%',
                                        }}
                                    >   
                                        <Row>
                                            {surveyTemplateModel?.programmeModelList?.map(item => 
                                                <Col span={8} key={item?.cohortProgId}>
                                                    <Checkbox value={item?.cohortProgId}>{item?.['progTitle' + language]}</Checkbox>
                                                </Col>      
                                            )}
                                        </Row>
                                    </Checkbox.Group>
                                </Form.Item>
                            </div>
                            <div className='boxFlexText'>
                                5= {trans.surveyScreenAgree[language]} &nbsp;&nbsp;&nbsp;&nbsp;1= {trans.surveyScreenDisAgree[language]}
                            </div>
                            {tables?.map((item, index) => 
                                <div className="websiteSysRow" key={item?.id}>
                                    <div className="websiteSysCol">
                                        <div className="websiteSysParam minBox mustFill">{index + 3}.{item?.question}</div>
                                        <div className="websiteSysInput boxFlex ">
                                            <Form.Item
                                                name={item?.id}
                                                rules={[
                                                    { required: true, message: trans.questionIsRequired[language] },
                                                ]}
                                            >
                                                <Radio.Group  buttonStyle="solid">
                                                    <Radio.Button value="5">5</Radio.Button>
                                                    <Radio.Button value="4">4</Radio.Button>
                                                    <Radio.Button value="3">3</Radio.Button>
                                                    <Radio.Button value="2">2</Radio.Button>
                                                    <Radio.Button value="1">1</Radio.Button>
                                                </Radio.Group>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {tabIndex == '2' && 
                        <div>
                            <div className='titleSize'>{trans.surveyScreenModel2[language]}</div>
                            <div className='websiteSysRow'>
                                <div className='websiteSysCol'>
                                    <div className='websiteSysParam websiteSysParamMiddle mustFill'>{tables.length + 2}.{surveyTemplateModel?.['sectionBQuestion1' + language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="sectionBQuestionResult1"
                                            rules={[
                                                { required: true, message: trans.sectionBQuestion1ResultIsRequired[language] },
                                            ]}
                                        >
                                            <InputNumber min={1} max={999} placeholder={surveyTemplateModel?.['sectionBQuestion1' + language]}/>
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='titleSize'>{trans.surveyScreenModel3[language]}</div>
                            {optionTables?.map((item, index) =>
                                <div key={item?.id}>
                                    <div className='flexBox'>
                                    <div className="label">{tables.length + 3 + index}.{item.question}</div>
                                    </div>
                                    <div className="flexBox">
                                        <div className="websiteSysInputMax marginBot">
                                            <Form.Item
                                                name={item?.id}
                                            >
                                                <TextArea maxLength={1000} rows={3} placeholder="" />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>    
                            )}
                            <div className='flexBox'>
                                <div className='value valueJustify marginTop'>
                                    {trans.surveyScreenThank[language]} 
                                </div>
                            </div>
                        </div>}
                    </Form>
                    <div className='websiteSysButtonBox margin2'>
                        {tabIndex == '1' && <div className='websiteSysButton signatureButton' onClick={() => handleSelect("2")}>{trans.surveyScreenNext[language]} &nbsp; <RightOutlined /></div>}
                        {tabIndex == '2' && <div className='websiteSysButton signatureButton' onClick={() => handleSelect("1")}><LeftOutlined/> &nbsp; {trans.surveyScreenPrevious[language]} </div>}
                        {tabIndex == '2' && <div className='websiteSysButton' onClick={() => form.submit()}><img src={submitImg} />{trans.surveyScreenSubmit[language]}</div>}
                    </div>
                </div>
            </Spin>
                : <div className='contentTitle flexCenter'>Link has failed.</div>
            }
        </div>
    )

}

export default SurveyScreen;